import { render, staticRenderFns } from "./DialogAnexarComprovante.vue?vue&type=template&id=c7227a1e&"
import script from "./DialogAnexarComprovante.vue?vue&type=script&lang=js&"
export * from "./DialogAnexarComprovante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports